<div class="panel-heading">
	<span>DIALOG &nbsp;</span>
	<input class="form-control" type="text" [(ngModel)]="typeaheadValue" style="display: inline; width: 200px" 
		[typeahead]="entities"
		(typeaheadLoading)="changeTypeaheadLoading($event)"
		(typeaheadOnSelect)="typeaheadOnSelect($event)"
		typeaheadOptionField="name" />	
</div>

<div *ngIf="dialog != null" class="panel panel-drk-ornge">
	<div class="panel-heading">
		BUTTON CODE
	</div>
	
	<div  class="panel-body">
		<div class="radio radio-default radio-inline">
			<input type="radio" [(ngModel)]="buttonId" value="-1" (change)="onButtonChange(-1)"/>
			<label>ANY</label>
		</div>	
		<ng-container *ngFor="let button of dialog.buttons">
			<div class="radio radio-default radio-inline">
				<input type="radio" [(ngModel)]="buttonId" value="{{button.code}}" (change)="onButtonChange(button.code)" />
				<label>{{button.label}}</label>
			</div>
		</ng-container>	
	</div>
</div>

<!-- Simple Success Error Dialog Box - Displaying the Error generated for now since we dont display success msgs -->
<ef-simple-success-error-dialog-box #successErrorDialog></ef-simple-success-error-dialog-box>